import { useTranslation } from 'react-i18next';

import { FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';
import { Can } from '@nucleus-commerce/admin-kit/permissions';

import { useStoreDetail } from '@/features/stores';
import { ReadOnlyBanner } from '@/shared/store/read-only-banner';
import { useStore } from '@/shared/store/store-context';
import { useStoreEditable } from '@/shared/store/use-store-editable';

import { PolicyDocumentsCard } from '../components/policy-documents-card';
import { PolicySettingsCard } from '../components/policy-settings-card';

function PolicySettingsSection({ storeId }: { storeId: string }) {
  // Prefetched by the route loader when the person may read settings.
  const { data: detail } = useStoreDetail(storeId);
  return detail ? <PolicySettingsCard key={detail.updatedAt} store={detail} /> : null;
}

function Policies() {
  const { t } = useTranslation('policies');
  const store = useStore();
  const { reason } = useStoreEditable({ permission: 'content.write' });

  return (
    <PageContent>
      <PageHeader
        title={t('title')}
        description={t('description', { store: store.name })}
        backTo={{ to: '/org/stores/$storeId', params: { storeId: store.id } }}
        backLabel={t('back')}
      />
      <ReadOnlyBanner reason={reason} className="max-w-3xl" />
      <div className="flex max-w-3xl flex-col gap-6">
        <PolicyDocumentsCard storeId={store.id} />
        <Can permission="settings.read">
          <PolicySettingsSection storeId={store.id} />
        </Can>
      </div>
    </PageContent>
  );
}

export function PoliciesPage() {
  return (
    <FeatureErrorBoundary name="policies.list">
      <Policies />
    </FeatureErrorBoundary>
  );
}
